import { dateTransformer } from "@/common/utils/dateTransformer"
import { transformDriverLicenseCategoriesToOptions } from "@/common/utils/driverLicenseCategoryTransformers"
import { formatCpf, formatPhoneNumber } from "@/common/utils/formatters"
import { CompanyUserData } from "@/features/privateCompanies/types/companyUsers.type"
import { statusOptions } from "@/features/users/constants/statusOptions.constant"

const formatPhone = (phone?: string) => {
  if (!phone) return undefined

  if (phone.length === 11) {
    return formatPhoneNumber(`55${phone}`)
  }

  return formatPhoneNumber(phone)
}

export const companyUserDefaultValues = (companyUser?: CompanyUserData) => ({
  cpf: companyUser?.cpf ? formatCpf(companyUser?.cpf) : undefined,
  date_of_birth: companyUser?.date_of_birth ? dateTransformer(companyUser?.date_of_birth) : undefined,
  full_name: companyUser?.full_name || undefined,
  branch_id: companyUser?.branch
    ? { label: companyUser?.branch.display_name, value: companyUser?.branch.id }
    : undefined,
  status: statusOptions.find(({ value }) => value === companyUser?.status) || undefined,
  phone: {
    number: formatPhone(companyUser?.phone?.number),
  },
  email: companyUser?.email || undefined,
  enrollment_number: companyUser?.enrollment_number || undefined,
  roles: companyUser?.user_roles?.map(({ role }) => ({ value: role.id, label: role.display_name })),
  current_driver_license_registration_number: companyUser?.current_driver_license_registration_number || undefined,
  current_driver_license_expiration_date: companyUser?.current_driver_license_expiration_date ? dateTransformer(companyUser?.current_driver_license_expiration_date) : undefined,
  user_driver_license_categories: transformDriverLicenseCategoriesToOptions(companyUser?.user_driver_license_categories || []),
  name_on_card: companyUser?.name_on_card || undefined,
})
